import { Button, Card } from "antd";
import { PaymentAdditionsViewModel } from "../../../interfaces";
import { AddonsForm } from "../Addons/AddonsForm";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../interfaces/users";
import { api } from "../../../config";
import { toast } from "react-toastify";
import { useState } from "react";
import { useQueries } from "react-query";
import {
  ModulePermission,
  userHasPermission,
} from "../../../utils/helpers/userHelpers";

interface PaymentsApprovementPanelProps {
  PaymentsAdditions: PaymentAdditionsViewModel[];
  ticketId: number;
  isApprovement?: boolean;
}

export const PaymentsApprovementPanel = ({
  PaymentsAdditions,
  ticketId,
  isApprovement,
}: PaymentsApprovementPanelProps) => {
  const [loading, setLoading] = useState(false);
  const { user, token } = useSelector((state: AuthenticationState) => state);

  const [{ refetch }, { refetch: boardRefetch }]: any = useQueries([
    {
      queryKey: `tickets/assemble`,
      queryFn: () => api(token).get(`ticket/assemble/${ticketId}`),
      refetchOnMount: false,
      retryOnMount: false,
    },
    {
      queryKey: "tickets/assemble/board",
      queryFn: () => api(token).get(`tickets/assemble/board`),
      refetchOnMount: false,
      retryOnMount: false,
    },
  ]);

  const handleApproveAdditions = async () => {
    setLoading(true);
    api(token)
      .post(`/payment/additions/approve/${ticketId}`, {})
      .then((response) => {
        boardRefetch();
        refetch();
      })
      .catch((error) => toast.error("Ocorreu um erro ao aprovar o adicional"))
      .finally(() => setLoading(false));
  };

  return (
    <Card
      className="mb-3"
      title="Adicionais"
      size="small"
      headStyle={{ color: " #1677FF" }}
    >
      <AddonsForm ticketAdditions={PaymentsAdditions} ticketId={ticketId} />
      {userHasPermission(user, { payments: ModulePermission.ADMIN }) && (
        <div>
          {isApprovement && (
            <Button
              color="primary"
              className="mt-5"
              onClick={handleApproveAdditions}
              loading={loading}
            >
              Aprovar Adicionais
            </Button>
          )}
        </div>
      )}
    </Card>
  );
};
